document.addEventListener('DOMContentLoaded', function() {
    // Detecta si el dominio es .it o .pt
    var domain = window.location.hostname;

    if (domain.endsWith('.it')) {
        // Reemplaza los enlaces para Italia
        var links = document.querySelectorAll('a'); // Selecciona todos los enlaces

        links.forEach(function(link) {
            if (link.href.includes('instagram.com')) {
                link.href = 'https://www.instagram.com/foodforjoe.it/';
            } else if (link.href.includes('facebook.com')) {
                link.href = 'https://www.facebook.com/foodforjoe.es/';
            } else if (link.href.includes('tiktok.com')) {
                link.href = 'https://www.tiktok.com/@foodforjoe';
            } else if (link.href.includes('linkedin.com')) {
                link.href = 'https://www.linkedin.com/company/food-for-joe/';
            }
        });
    } else if (domain.endsWith('.pt')) {
        // Reemplaza los enlaces para Portugal
        var links = document.querySelectorAll('a'); // Selecciona todos los enlaces

        links.forEach(function(link) {
            if (link.href.includes('instagram.com')) {
                link.href = 'https://www.instagram.com/foodforjoe/';
            } else if (link.href.includes('facebook.com')) {
                link.href = 'https://www.facebook.com/foodforjoe.es/';
            } else if (link.href.includes('tiktok.com')) {
                link.href = 'https://www.tiktok.com/@foodforjoe';
            } else if (link.href.includes('linkedin.com')) {
                link.href = 'https://www.linkedin.com/company/food-for-joe/';
            }
        });
    }
});